import m from "mithril";
import { MithrilTsxComponent } from "mithril-tsx-component";
import { cleanString } from "oj-utils";
import { getAsset } from "../../utils/utils";
import { Svg } from "../svg/svg";
import "./button.scss";
export class Button extends MithrilTsxComponent {
    view(v) {
        const { text, className, icon, iconReverse, disabled, ...rest } = v.attrs;
        return m("button", { type: "button", className: cleanString("button", className, disabled && "-disabled", (icon && !text) && "icon-only"), disabled: disabled, ...rest },
            icon && iconReverse && m(Svg, { className: "icon", src: getAsset(icon) }),
            text && m("span", null, text),
            v.children,
            icon && !iconReverse && m(Svg, { className: "icon", src: getAsset(icon) }));
    }
}
